import React, {useEffect, useState} from 'react';
import {useDispatch} from "react-redux";
import moment from "moment";
import {addPrefix} from "../../../utils/UriUtil";
import {jsonResponseHandler, revenueResponseHandler} from "../../../utils/FetchHelper";
import classnames from "classnames";
import {number_format} from "../../../utils/formatter";
import If from "../../common/control/If";

const RevenueStatusSummary = ({vendor}) => {
  const [date, setDate] = useState(new Date());
  const [data, setData] = useState(null);
  const [beforeData, setBeforeData] = useState(null);
  const [renderData, setRenderData] = useState(null);
  const [error, setError] = useState(false);
  const [showLayerPopup, setShowLayerPopup] = useState(false);
  const dispatch = useDispatch();

  const fetchData = () => {
    setError(false);
    let date = new Date();
    let dateString = '';
    if (date.getHours() < 10) {
      dateString = moment(date).subtract(2, 'days').format('YYYY-MM-DD');
      date = moment(date).subtract(2, 'days').toDate();
      setDate(date);
    } else {
      dateString = moment(date).subtract(1, 'days').format('YYYY-MM-DD');
      date = moment(date).subtract(1, 'days').toDate();
      setDate(date);
    }
    fetch(addPrefix(`/manage/revenue/info/${vendor}.json?granularity=day&startDate=${dateString}&endDate=${dateString}`), {
      credentials: "include",
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(jsonResponseHandler(dispatch))
      .then(revenueResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        const all = data.data.filter((ele) => ele.id === 'all');
        setData(all[0]);
      })
      .catch(e => {
        console.error(e);
        setError(true);
      });
    dateString = moment(date).subtract(1, 'days').format('YYYY-MM-DD');
    fetch(addPrefix(`/manage/revenue/info/${vendor}.json?granularity=day&startDate=${dateString}&endDate=${dateString}`), {
      credentials: "include",
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(jsonResponseHandler(dispatch))
      .then(revenueResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        const all = data.data.filter((ele) => ele.id === 'all');
        setBeforeData(all[0]);
      })
      .catch(e => {
        console.error(e);
        setError(true);
      });
  };
  const LoadingElement = ({condition, children}) => {
    return (
      <>
        <If condition={condition}>
          {children}
        </If>
        <If condition={!condition}>
          <dd className="revenue_cont">
            <div className="box_loading">
              <span className="ico_blog ico_loading">로딩중입니다.</span>
            </div>
          </dd>
        </If>
      </>
    );
  };

  useEffect(() => {
    if (data && beforeData) {
      setRenderData({
        impression: data.impression,
        impressionVariation: data.impression - beforeData.impression,
        clicks: data.clicks,
        clicksVariation: data.clicks - beforeData.clicks,
        rpm: data.rpm,
        rpmVariation: data.rpm - beforeData.rpm,
        earnings: data.earnings,
        earningsVariation: data.earnings - beforeData.earnings,
      });
    }
  }, [data, beforeData]);

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      <div className="wrap_cont wrap_cont_type2"><span className="num_date">
        {date.getFullYear()}. {date.getMonth() + 1}. {date.getDate()} 기준
      </span></div>
      <a className="btn_type5 btn_type5_type4" onClick={() => window.location = `/manage/revenue/${vendor}`}>상세 보기</a>
      {!error &&
      <div className="box_revenue_plat">
        <div>
          <dl className="count_revenue">
            <dt className="tit_revenue">노출수</dt>
            <LoadingElement condition={renderData}>
              {renderData &&
              <dd className="revenue_cont">
                <div className="revenue_val">
                  <span className="num_g">{number_format(renderData.impression)}</span>
                </div>
                <div className="revenue_chg">
                                <span
                                  className={classnames('num_g', renderData.impressionVariation >= 0 ? 'num_up' : 'num_down')}>
                                    {number_format(Math.abs(renderData.impressionVariation))}
                                </span>
                  <span
                    className={classnames('ico_blog', renderData.impressionVariation >= 0 ? 'ico_up' : 'ico_down')}>
                                    {renderData.impressionVariation >= 0 ? '상승' : '하락'}
                                </span>
                </div>
              </dd>
              }
            </LoadingElement>
          </dl>
          <dl className="count_revenue">
            <dt className="tit_revenue">클릭수</dt>
            <LoadingElement condition={renderData}>
              {renderData &&
              <dd className="revenue_cont">
                <div className="revenue_val">
                  <span className="num_g">{number_format(data.clicks)}</span>
                </div>
                <div className="revenue_chg">
                                <span
                                  className={classnames('num_g', renderData.clicksVariation >= 0 ? 'num_up' : 'num_down')}>
                                    {number_format(Math.abs(renderData.clicksVariation))}
                                </span>
                  <span
                    className={classnames('ico_blog', renderData.clicksVariation >= 0 ? 'ico_up' : 'ico_down')}>
                                    {renderData.clicksVariation >= 0 ? '상승' : '하락'}
                                </span>
                </div>
              </dd>
              }
            </LoadingElement>
          </dl>
          <dl className="count_revenue">
            <dt className="tit_revenue">
              {vendor === 'adsense' &&
              '노출 RPM '
              }
              {vendor === 'adfit' &&
              'eCPM '
              }
              <div className={classnames('wrap_question', showLayerPopup ? 'open_question' : '')}
                   onMouseEnter={()=>setShowLayerPopup(true)}
                   onMouseLeave={()=>setShowLayerPopup(false)}
              >
                <span className="ico_blog ico_question">설명</span>
                <div className="layer_popup">
                  <div className="inner_popup inner_popup_type3">
                    <p className="desc_g">광고가 1,000회 노출됐을 때 얻을<br/> 수 있는 예상 수익을 말합니다.</p>
                  </div>
                </div>
              </div>
            </dt>
            <LoadingElement condition={renderData}>
              {renderData &&
              <dd className="revenue_cont">
                <div className="revenue_val">
                  <span className="num_g">{number_format(data.rpm)}</span>
                </div>
                <div className="revenue_chg">
                                <span
                                  className={classnames('num_g', renderData.rpmVariation >= 0 ? 'num_up' : 'num_down')}>
                                    {number_format(Math.abs(renderData.rpmVariation))}
                                </span>
                  <span
                    className={classnames('ico_blog', renderData.rpmVariation >= 0 ? 'ico_up' : 'ico_down')}>
                                    {renderData.rpmVariation >= 0 ? '상승' : '하락'}
                                </span>
                </div>
              </dd>
              }
            </LoadingElement>
          </dl>
          <dl className="count_revenue">
            <dt className="tit_revenue">수익</dt>
            <LoadingElement condition={renderData}>
              {renderData &&
              <dd className="revenue_cont">
                <div className="revenue_val">
                  <span className="num_g">{number_format(data.earnings)}</span>
                  {vendor === 'adfit' &&
                  <span className="txt_g">원</span>
                  }
                  {vendor === 'adsense' &&
                  <span className="txt_g">USD</span>
                  }
                </div>
                <div className="revenue_chg">
                                <span
                                  className={classnames('num_g', renderData.earningsVariation >= 0 ? 'num_up' : 'num_down')}>
                                    {number_format(Math.abs(renderData.earningsVariation))}
                                </span>
                  <span
                    className={classnames('ico_blog', renderData.earningsVariation >= 0 ? 'ico_up' : 'ico_down')}>
                                    {renderData.earningsVariation >= 0 ? '상승' : '하락'}
                                </span>
                </div>
              </dd>
              }
            </LoadingElement>
          </dl>
        </div>
      </div>
      }
      {error &&
      <div className="box_revenue_plat">
        <div className="statistic_refresh info_none">
          <div className="inner_refresh">
            <span className="wrap_ico"><span className="ico_blog ico_post"/></span>
            <a className="link_none" onClick={fetchData}>다시 조회하기</a>
          </div>
        </div>
      </div>
      }
    </>
  )
};

export default RevenueStatusSummary;